import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cd_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.";
  if (typeof detail === "string") {
    const looksLikeHtml = /<\/?[a-z!][^>]*>/i.test(detail) || detail.length > 300;
    if (looksLikeHtml) return "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.";
    return detail;
  }
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_7c0de6a3-be23-4380-b785-897a36884bae/artifacts/ckqjzfgn_Logo%20Canto%20Dei.png";

export const AGB_URL = "https://canto-dei.com/allgemeine-geschaftsbedingungen-agb/";
export const DATENSCHUTZ_URL = "https://canto-dei.com/datenschutzerklaerung/";
export const IMPRESSUM_URL = "https://canto-dei.com/impressum/";
export const BEISPIELSONGS_URL =
  "https://canto-dei.com/beispielsongs-marotta-musikkomposition-canto-dei/";
export const KONTAKT_EMAIL = "info@canto-dei.com";

export const MUSIKSTILE = [
  "Piano & Strings",
  "Ambient / Neoklassik",
  "Akustisch",
  "Cinematic Minimal",
  "Chor & Orgel",
  "Soft Rock",
  "Blues Piano",
  "Jazz Ballade",
  "Folk Acoustic",
  "Celtic Folk",
  "Country Ballade",
  "Pop Ballade",
  "Indie Acoustic",
  "Dream Pop",
  "LoFi Ambient",
  "Ethereal Vocal",
  "Schlager Ballade",
  "Chanson Stil",
  "Gospel Soft",
  "Female Vocal Ballade",
  "Male Vocal Ballade",
  "Soul Ballade",
  "R&B Slow",
  "Cinematic Orchester",
  "Nordisch Ambient",
  "Minimal Piano",
  "Singer-Songwriter",
  "Emotional Rap",
  "Spoken Word",
  "Soft Punk Rock",
];
